import React, { Component } from "react";
import ReportHeader from "../../../Report/ReportHeader";
import axios from "axios";
import Spinner from "../../../Common/Spinner";
import * as appConst from "../../../Common/constants";
import moment from "moment";

export default class Account extends Component {
  constructor(props) {
    super(props);

    this.state = {
      bankBalance: "NA",
      bankLedger: "NA",
      entries: "NA",
      spinnerClass: "",
      dataClass: "collapse"
    };
  }

  componentDidMount() {
    const data = {
      fromDate: this.props.data.fromDate
    };

    axios
      .post(
        (process.env.NODE_ENV !== "development"
          ? appConst.API_URL_PROD
          : appConst.API_URL_DEV) + "/account/daybookBalance",
        data
      )
      .then(res => {
        this.setState({
          bankBalance: res.data
        });
      });

    axios
      .post(
        (process.env.NODE_ENV !== "development"
          ? appConst.API_URL_PROD
          : appConst.API_URL_DEV) + "/account/daybookLedger",
        data
      )
      .then(res => {
        this.setState({
          entries: res.data,
          spinnerClass: "collapse",
          dataClass: ""
        });
      });
  }

  tabBankBalance() {
    if (this.state.bankBalance !== "NA") {
      return this.state.bankBalance.map(obj => {
        var openParts = obj.openingBal.toString().split(".");
        var open =
          openParts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",") +
          (openParts[1] ? "." + openParts[1] : ".00");
        var closeParts = obj.closingBal.toString().split(".");
        var close =
          closeParts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",") +
          (closeParts[1] ? "." + closeParts[1] : ".00");
        return (
          <div className="row" key={obj.bankName}>
            <div className="col col-md-6 border">{obj.bankName}</div>
            <div className="col col-md-3 border" align="right">
              {open}
            </div>
            <div className="col col-md-3 border" align="right">
              {close}
            </div>
          </div>
        );
      });
    }
  }

  // tabBankLedger() {
  //   if (this.state.bankLedger !== "NA") {
  //     return this.state.bankLedger.ledger.map(obj => {
  //       let amt = obj.amount;

  //       if (obj.txnType === "Withdraw") {
  //         amt *= -1;
  //       }

  //       var amountParts = amt.toString().split(".");

  //       var amount =
  //         amountParts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",") +
  //         (amountParts[1] ? "." + amountParts[1] : ".00");

  //       var income = 0,
  //         expense = 0;

  //       if (obj.txnType === "Deposit") income = amount;
  //       else expense = amount;

  //       return (
  //         <div className="row" key={obj._id}>
  //           <div className="col col-md-6 border">{obj.bankName}</div>
  //           <div className="col col-md-3 border" align="right">
  //             {income}
  //           </div>
  //           <div className="col col-md-3 border" align="right">
  //             {expense}
  //           </div>
  //         </div>
  //       );
  //     });
  //   }
  // }

  // tabBankTotal() {
  //   if (this.state.bankLedger !== "NA") {
  //     var depParts = this.state.bankLedger.totalDeposit.toString().split(".");
  //     var dep =
  //       depParts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",") +
  //       (depParts[1] ? "." + depParts[1] : ".00");

  //     var witParts = this.state.bankLedger.totalWithdraw.toString().split(".");
  //     var wit =
  //       witParts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",") +
  //       (witParts[1] ? "." + witParts[1] : ".00");

  //     return (
  //       <div className="row">
  //         <div className="col col-md-6 border">
  //           <h5>Total</h5>
  //         </div>
  //         <div className="col col-md-3 border" align="right">
  //           <h5>{dep}</h5>
  //         </div>
  //         <div className="col col-md-3 border" align="right">
  //           <h5>{wit}</h5>
  //         </div>
  //       </div>
  //     );
  //   }
  // }

  tabEntries() {
    if (this.state.entries !== "NA") {
      return this.state.entries.ledger.map(obj => {
        var amt = obj.amount;
        if (obj.txntype === "Expense") amt *= -1;

        var amountParts = amt.toString().split(".");

        var amount =
          amountParts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",") +
          (amountParts[1] ? "." + amountParts[1] : ".00");

        var income = 0,
          expense = 0,
          bankName;

        if (obj.txntype === "Income") income = amount;
        else expense = amount;

        if (obj.bankName === "") bankName = "Cash";
        else bankName = obj.bankName;

        return (
          <div className="row" key={obj._id}>
            <div className="col col-md-2 border">{obj.type}</div>
            <div className="col col-md-4 border">{obj.desc}</div>
            <div className="col col-md-2 border">{bankName}</div>
            <div className="col col-md-2 border" align="right">
              {income}
            </div>
            <div className="col col-md-2 border" align="right">
              {expense}
            </div>
          </div>
        );
      });
    }
  }

  tabEntriesTotal() {
    if (this.state.entries !== "NA") {
      var incParts = this.state.entries.totalIncome.toString().split(".");
      var inc =
        incParts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",") +
        (incParts[1] ? "." + incParts[1] : ".00");

      var expParts = this.state.entries.totalExp.toString().split(".");
      var exp =
        expParts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",") +
        (expParts[1] ? "." + expParts[1] : ".00");

      return (
        <div className="row">
          <div className="col col-md-4 border"></div>
          <div className="col col-md-4 border">
            <h5>Total</h5>
          </div>
          <div className="col col-md-2 border" align="right">
            <h5>{inc}</h5>
          </div>
          <div className="col col-md-2 border" align="right">
            <h5>{exp}</h5>
          </div>
        </div>
      );
    }
  }

  DisplayFilter() {
    var arrFrom = new Date(this.props.data.fromDate).toDateString().split(" ");
    return arrFrom[2] + "-" + arrFrom[1] + "-" + arrFrom[3];
  }

  render() {
    return (
      <div>
        <ReportHeader onCloseClick={this.onCloseClick} IsClose="1" />
        <h3 align="center">Day Book - {this.DisplayFilter()}</h3>
        <div className={this.state.spinnerClass}>
          <Spinner />
        </div>
        <div className={this.state.dataClass}>
          <div className="container-fluid reportFont">
            <div className="row">
              <div className="col col-md-6 border" align="center">
                <h4>Cash</h4>
              </div>
              <div className="col col-md-3 border" align="center">
                <h4>Opening Balance</h4>
              </div>
              <div className="col col-md-3 border" align="center">
                <h4>Closing Balance</h4>
              </div>
            </div>
            {this.tabBankBalance()}
            <div className="row">&nbsp;</div>
            <div className="row">
              <div className="col col-md-2 border" align="center">
                <h4>Particulars</h4>
              </div>
              <div className="col col-md-4 border" align="center">
                <h4>Description</h4>
              </div>
              <div className="col col-md-2 border" align="center">
                <h4>Bank / Cash</h4>
              </div>
              <div className="col col-md-2 border" align="center">
                <h4>Income</h4>
              </div>
              <div className="col col-md-2 border" align="center">
                <h4>Expense</h4>
              </div>
            </div>
            {this.tabEntries()}
            {this.tabEntriesTotal()}
          </div>
        </div>
      </div>
    );
  }

  onCloseClick = e => {
    this.props.onCloseClick("Filter", null);
  };
}
